import { Controller } from "react-hook-form";
import { ContentPageEditProps } from "..";
import FormFieldErrors from "../../Form/FormFieldErrors";
import { TextInput } from "djinn-components";
import Form from "../../Form";
import { toast } from "react-toastify";
import { useSiteState } from "../../../utils/useSiteState";
import { emailRegex } from "../../../utils/regex";

const ContentPageEditSupport: React.FC<ContentPageEditProps> = ({ page }) => {
  const { site } = useSiteState();

  const getDefaults = () => {
    const { page_template_config } = page;

    return {
      page_template_config,
    };
  };

  const onSubmit = async (responseData: any) => {
    // await fetchUser();
    toast("Page content updated", { type: "success" });
  };

  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Update Content"
      endpoint={`sites/${site.id}/pages/${page.id}`}
      method="put"
      className="w-full text-white"
      render={({ errors, control }) => (
        <>
          <div className="mb-4 mt-10">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Header Text
            </label>
            <Controller
              name="page_template_config.contact_details_head"
              control={control}
              defaultValue=""
              rules={{
                required: false,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <TextInput
                  value={value}
                  onChange={onChange}
                  invalid={!!errors?.page_template_config?.contact_details_head}
                  placeholder="Contact Details Header"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="page_template_config.contact_details_head"
            />
          </div>

          <div className="mb-4 mt-6">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Subtitle Text
            </label>
            <Controller
              name="page_template_config.contact_details_subtitle"
              control={control}
              defaultValue=""
              rules={{
                required: false,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <TextInput
                  value={value}
                  onChange={onChange}
                  invalid={
                    !!errors?.page_template_config?.contact_details_subtitle
                  }
                  placeholder="Contact Details Subtext"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="page_template_config.contact_details_subtitle"
            />
          </div>

          <div className="mb-4 mt-6">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Phone number (optional)
            </label>
            <Controller
              name="page_template_config.phone_number"
              control={control}
              defaultValue=""
              rules={{
                required: false,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <TextInput
                  value={value}
                  onChange={onChange}
                  invalid={!!errors?.page_template_config?.phone_number}
                  placeholder="Contact Phone number"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="page_template_config.phone_number"
            />
          </div>

          <div className="mb-4 mt-6">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Email Address (optional)
            </label>
            <Controller
              name="page_template_config.email_address"
              control={control}
              defaultValue=""
              rules={{
                required: false,
                pattern: emailRegex,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <TextInput
                  value={value}
                  onChange={onChange}
                  invalid={!!errors?.page_template_config?.email_address}
                  placeholder="Contact Email address"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="page_template_config.email_address"
              matchMessage="This must be a valid email address"
            />
          </div>

          <div className="mb-10 mt-6">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Address (optional)
            </label>
            <Controller
              name="page_template_config.address"
              control={control}
              defaultValue=""
              rules={{
                required: false,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <TextInput
                  value={value}
                  onChange={onChange}
                  invalid={!!errors?.page_template_config?.address}
                  placeholder="Contact address"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="page_template_config.address"
            />
          </div>
        </>
      )}
    />
  );
};

export default ContentPageEditSupport;
